import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    rolesExpanded: {},
};

const permissionsUi = createSlice({
    name: 'permissionsUi',
    initialState,
    reducers: {
        setRolesExpanded(state, action) {
            state.rolesExpanded = action.payload || {};
        },
        clearRolesExpanded(state) {
            state.rolesExpanded = {};
        },
    }
});

export const { setRolesExpanded, clearRolesExpanded } = permissionsUi.actions;

export default permissionsUi.reducer;